<template>
  <div class="kye-navbar noselect kye-contrast-off" :style="{left: `${paddingLeft}px`}">
    <span class="scroll-btn scroll-btn--left" @click="handleScrollLeft" v-show="isShowLeftBtn">
      <i class="layout layout-arrow-left2" />
    </span>
    <div
      class="scroll-container"
      ref="scrollContainer"
      :class="{'show-left-mask': isShowLeftBtn, 'show-right-mask': isShowRightBtn}"
      @wheel.prevent="handleScroll">
      <draggable
        ref="scrollWrapper"
        class="scroll-wrapper"
        :style="{left: `${left +12}px`}"
        :list="visitedViews"
        v-bind="dragOptions"
        @end="handleDragEnd">
        <a v-for="tag in visitedViews"
           :key="tag.tag"
           :class="tagClass(tag.tag)"
           :style="tagStyle(tag.tag)"
           :path="tag.path"
           ref="tags"
           @click="pushRoute(tag.path, tag.tag, false, true)"
           @mouseenter="handleIconEnter($event)"
           @mouseleave="handleIconLeave($event, tag.tag)"
           @contextmenu.prevent="openMenu(tag, $event)">
          <div>
            <i class="system-icon layout" :class="systemIcon(tag.tag)" />
            {{tag.title}}
            <i v-if="defaultOpenTags.includes(tag.tag)" class="layout layout-lock nav-lock-icon" />
          </div>
          <i v-if="tag.tag !== '/'" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"></i>
        </a>
      </draggable>
    </div>
    <span class="scroll-btn scroll-btn--right" @click="handleScrollRight" v-show="isShowRightBtn">
      <i class="layout layout-arrow-right2" />
    </span>
    <div style="position:absolute;bottom:0px;left:0px;width:100%">
      <ul class='contextmenu' v-show="visible" :style="{left: menuLeft}">
        <li v-show="!isLock" @click="setDefaultViews()">下次默认打开</li>
        <li  v-show="isLock" @click="setDefaultViews(true)">解锁</li>
        <li v-show="showClose" @click="closeSelectedTag(selectedTag)">关闭</li>
        <li v-show="showClose" @click="closeOthersTags">关闭其它</li>
        <li v-show="showClose" @click="closeAllTags">关闭全部</li>
        <li @click="openBlank">打开新窗口</li>
        <li @click="addHome(selectedTag)">添加到首页</li>
      </ul>
    </div>
    <a ref="href" rel="opener" hidden target="_blank" :href="`/#${selectedTag.path || '/'}`"></a>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import { checkAppraise } from './setup/check-appraise'
  import { QtReportChangeTab } from '@/layout/utils/report-qt.js'
  import DefaultOpenStore from './setup/default-open-tabs'
  // 标签宽度
  const TAG_WIDTH = 100
  // 滚动距离
  const SCROLL_UNIT = TAG_WIDTH * 3

  export default {
    name: 'navbar',
    components: { draggable },
    props: {
      paddingLeft: Number
    },
    data () {
      return {
        left: 0,
        menuLeft: '0px',
        visible: false,
        tag: '',
        selectedTag: {},
        dragOptions: {
          draggable: '.tag',
          handle: '.tag',
          animation: 150,
          ghostClass: 'kye-ghost'
        },
        isShowRightBtn: false,
        isShowLeftBtn: false
      }
    },
    mounted () {
      this.tag = this.$route.meta.tag
      this.clientWidth = window.innerWidth

      window.addEventListener('keydown', this.keydownEvent)
    },
    beforeDestroy () {
      window.removeEventListener('keydown', this.keydownEvent)
    },
    computed: {
      menus () {
        return this.$store.state.menus
      },
      menusTree () {
        return this.$store.getters.menus.menuTree
      },
      visitedViews () {
        return this.$store.state.tagsView.visitedViews
      },
      showClose () {
        return this.selectedTag.tag !== '/'
      },
      defaultOpenTags () {
        return DefaultOpenStore.defaultOpenViews.map(v => v.tag)
      },
      isLock () {
        return this.defaultOpenTags.includes(this.selectedTag.tag)
      }
    },
    watch: {
      $route (val) {
        this.tag = val.meta.tag
        this.scrollIntoViewNarItem()
      },
      visible (value) {
        if (value) {
          document.body.addEventListener('click', this.closeMenu)
        } else {
          document.body.removeEventListener('click', this.closeMenu)
        }
      },
      visitedViews (val, oldVal) {
        this.updateScrollState()
      }
    },
    methods: {
      tagClass (tag) {
        return tag === this.tag ? 'tag is-active' : 'tag'
      },
      tagStyle (tag) {
        return tag === this.tag && tag !== '/' ? { backgroundColor: '#ffffff' } : null
      },
      systemIcon(tag) {
        if (!this.menus[tag]) {
          return ''
        }
        const { menuCode, subSystem } = this.menus[tag]
        const obj = this.menusTree.find(k => {
          const ksys = k.subSystem
          return (ksys.includes(',') && ksys.split(',').includes(subSystem)) || (ksys === subSystem)
        })
        if (!obj) {
          return ''
        }
        let str = obj.subSystem.toLowerCase().replace(/,/g, '')
        const iconClass = tag === this.tag ? 'light' : 'gray'
        // 首页
        if (menuCode === '/') {
          str = 'home'
        }
        return `layout-module-${str}-${iconClass}`
      },
      handleIconEnter (e) {
        const iconEl = e.currentTarget.querySelector('.system-icon')
        if (iconEl && !iconEl.className.includes('-light')) {
          iconEl.className = iconEl.className.replace(/-gray/g, '-light')
        }
      },
      handleIconLeave (e, tag) {
        const iconEl = e.currentTarget.querySelector('.system-icon')
        if (iconEl) {
          if (tag !== this.tag && !iconEl.className.includes('-gray')) {
            iconEl.className = iconEl.className.replace(/-light/g, '-gray')
          }
        }
      },
      // user: 用户手动切换的该模块
      pushRoute (path, tag, keep, user) {
        // 从框架布局进入，添加入口标记
        const route = this.$router.resolve(path).route
        route.meta.layout = true
        this.$router.push(path)
        this.$bus.$emit('TAB_CLICK', path, tag, keep)
        user && QtReportChangeTab(path)
      },
      async closeSelectedTagEvent (tag) {
        await checkAppraise(tag, this.$route)
        this.$store.dispatch('delVisitedViews', tag).then(views => {
          if (tag.path === this.$route.fullPath) {
            if (views.length) {
              let view = views[views.length - 1]
              this.pushRoute(view.path, view.tag, true)
            } else {
              this.pushRoute('/', '/', true)
            }
          }
          if (this.defaultOpenTags.includes(tag.tag)) {
            // 关闭同时解锁页签
            DefaultOpenStore.setDefaultOpenTabs(true, tag, false)
          }
        })
      },
      closeSelectedTag (tag) {
        if (tag.closeTag) {
          // 当前页面未加载，内部js未执行监听
          const reloadRoutes = window.__ERP_reloadRoutes
          if (reloadRoutes[tag.tag]) {
            this.closeSelectedTagEvent(tag)
            return
          }
          // 用户需要监听关闭事件
          this.$bus.$emit('GLOBAL_CLOSE_TAG', tag, this.closeSelectedTagEvent)
        } else if (tag.path !== tag.tag && tag.pageType !== 'detail') {
          // 模块的新增、编辑页，提示保存数据
          this.$confirm(window.__ERPGLOABLECONFIG__.saveTips, '提示').then(_ => {
            this.closeSelectedTagEvent(tag)
          }).catch(console.log)
        } else {
          this.closeSelectedTagEvent(tag)
        }
      },
      async closeOthersTags () {
        try {
          await this.$confirm('您确定要关闭其它模块？', '提示')
          this.left = 0
          this.pushRoute(this.selectedTag.path, this.selectedTag.tag)
          this.$store.dispatch('delOthersViews', this.selectedTag)
          // 同时解锁其他页签
          DefaultOpenStore.unLockOtherTabs(this.selectedTag)
        } catch (e) {
          console.log(e)
        }
      },
      async closeAllTags () {
        try {
          await this.$confirm('您确定要关闭全部模块？', '提示')
          this.left = 0
          this.$store.dispatch('delAllViews')
          this.pushRoute('/', '/', true)
          // 同时解锁所有页签
          DefaultOpenStore.unLockAllTabs()
        } catch (e) {
        }
      },
      openMenu (tag, e) {
        this.visible = true
        this.selectedTag = tag
        let x = e.clientX
        if (x > this.clientWidth - 84) {
          x -= 84
        }
        this.menuLeft = `${x - this.paddingLeft - 20}px`
      },
      closeMenu () {
        this.visible = false
      },
      openBlank () {
        this.$refs.href.dispatchEvent(new MouseEvent('click'))
      },
      // 菜单添加到首页 常用模块
      async addHome (data) {
        try {
          // 获取 已添加到的常用模块
          const itemList = await this.getHomeIndexList()
          // 检查模块是否已经 存在
          if (itemList.some(v => v.url === data.path)) {
            this.$message.warning('此模块已存在')
            return false
          }
          const menuGroup = {
            moduleGroupId: 1,
            moduleGroupName: '未分组模块',
            moduleType: 10
          }
          // 菜单信息
          const menus = this.$store.getters.menus
          // 获取要添加的 菜单信息
          const obj = {
            icon: '',
            title: menus[data.path].title,
            url: data.path,
            ...menuGroup
          }
          itemList.unshift(obj)
          // 添加保存参数
          itemList.forEach((item, i) => {
            item.displaySequence = i + 1
            item.icon = ''
            item.moduleGroupId = '1'
            item.moduleGroupName = '未分组模块'
            item.moduleType = '10'
          })
          const addList = [obj]
          const params = { ...menuGroup, itemList, addList }
          console.log(params)
          await this.$http('system.homeIndex.save', params)
          this.$bus.$emit('GLOABL_HOME_UPDATE_MENU')
          this.$message.success('添加成功！')
        } catch (err) {
          console.log(err)
        }
      },
      // 获取 已添加到的常用模块
      async getHomeIndexList () {
        try {
          const res = await this.$http('system.homeModuleGroup.show', { moduleType: '10' }, false)
          const group = res.find(item => +item.defaultGroupFlag === 1)
          if (!group) {
            return []
          }
          const { itemList } = group
          return itemList
        } catch (e) {
          console.log(e)
        }
      },
      handleScroll (e) {
        this.container = this.container || this.$refs.scrollContainer
        this.wrapper = this.wrapper || this.$refs.scrollWrapper.$el
        const eventDelta = e.wheelDelta || -e.deltaY * 3
        if (eventDelta > 0) {
          this.left = Math.min(0, this.left + eventDelta)
        } else {
          const containerWidth = this.container.offsetWidth
          const wrapperWidth = this.wrapper.offsetWidth
          if (containerWidth < wrapperWidth) {
            if (this.left >= -(wrapperWidth - containerWidth)) {
              this.left = Math.max(this.left + eventDelta, containerWidth - wrapperWidth)
            }
          } else {
            this.left = 0
          }
        }
        this.updateScrollState()
      },
      handleScrollRight () {
        const { containerWidth, scrollWidth } = this.getWidth()
        if (-this.left + SCROLL_UNIT + containerWidth > scrollWidth) {
          this.left = containerWidth - scrollWidth
        } else {
          this.left = this.left - SCROLL_UNIT
        }
        this.updateScrollState()
      },
      handleScrollLeft () {
        this.left = this.left + SCROLL_UNIT >= 0 ? 0 : this.left + SCROLL_UNIT
        this.updateScrollState()
      },
      updateScrollState () {
        this.$nextTick(() => {
          const { containerWidth, scrollWidth } = this.getWidth()
          this.isShowLeftBtn = this.left !== 0
          this.isShowRightBtn = containerWidth - this.left < scrollWidth
        })
      },
      getWidth () {
        const scrollWidth = this.$refs.scrollWrapper.$el.getBoundingClientRect().width
        const containerWidth = this.$refs.scrollContainer.getBoundingClientRect().width

        return {
          containerWidth: Math.round(containerWidth),
          scrollWidth: Math.round(scrollWidth)
        }
      },
      scrollIntoViewNarItem () {
        try {
          clearTimeout(this._scrollIntoViewNarTimer)
          this._scrollIntoViewNarTimer = setTimeout(() => {
            this.$nextTick(() => {
              // const activeTagIndex = this.visitedViews.findIndex(v => v.tag === this.tag)
              const activeEl = this.$el.querySelector('.is-active')
              // 检查是否在可视区域内
              if (activeEl) {
                const activeElLeft = activeEl.offsetLeft
                const activeElRight = activeElLeft + activeEl.offsetWidth
                const containerWidth = this.$refs.scrollContainer.offsetWidth
                const wrapperWidth = this.$refs.scrollWrapper.$el.offsetWidth
                const maxScrollLeft = Math.max(0, wrapperWidth - containerWidth)

                // 检查是否在可视区域内
                const isActiveElOutOfView = activeElLeft < -this.left || activeElRight > -this.left + containerWidth

                if (isActiveElOutOfView) {
                  let _left = 0
                  if (activeElLeft < -this.left) { // 如果标签在可视区域左侧外部
                    _left = -activeElLeft
                  } else if (activeElRight > -this.left + containerWidth) { // 如果标签在可视区域右侧外部
                    // 计算使标签居中的位置
                    _left = -(activeElLeft - (containerWidth - activeEl.offsetWidth) / 2)
                    // 确保不会超出左边界
                    _left = Math.min(_left, 0)
                  }

                  // 边界检查 - 确保不会超出右边界
                  if (_left < -maxScrollLeft) {
                    _left = -maxScrollLeft
                  }

                  this.left = _left
                }
                this.updateScrollState()
              }
            })
          }, 300)
        } catch (e) {
          console.error(e)
        }
      },
      // 设置 下次默认打开/解锁
      async setDefaultViews (isUnLock) {
        DefaultOpenStore.setDefaultOpenTabs(isUnLock, this.selectedTag)
      },
      // 拖动页签，同时设置默认页签顺序
      handleDragEnd () {
        const tagSort = this.visitedViews.map(tag => tag.tag)
        DefaultOpenStore.changeDefaultTabsOrder(tagSort)
      },
      keydownEvent (e) {
        // alt + 上下快捷键
        if (e.altKey && [38, 40].includes(e.keyCode)) {
          const isLeft = e.keyCode === 38
          const len = this.visitedViews.length
          const curIndex = this.visitedViews.findIndex(v => v.tag === this.tag)
          let nextIndex = curIndex === len - 1 ? 0 : curIndex + 1
          if (isLeft) {
            nextIndex = curIndex === 0 ? len - 1 : curIndex - 1
          }
          const nextTag = this.visitedViews[nextIndex]
          this.pushRoute(nextTag.path, nextTag.tag, false, true)
        }
      }
    }
  }
</script>

<style lang="scss">
  .kye-navbar {
    position: absolute;
    top: 50px;
    right: 0;
    padding: 0;
    // background-color: var(--g-theme-navbar-bg);
    // background-image: var(--g-theme-navbar-bg-image, none);
    // background-size: auto 78px, 100% 100%;
    // background-repeat: no-repeat, no-repeat;
    // background-position: bottom right, center;
    display: flex;
    align-items: center;
    z-index: 100;
    @mixin rounded-corner($type) {
      content: '';
      width: 14px;
      height: 14px;
      background-color: inherit;
      mask-size: contain;
      mask-repeat: no-repeat;
      bottom: -1px;
      position: absolute;
      @if $type == 'after' {
        mask-image: url('./images/radius-r.png');
        right: -12px;
      } @else {
        mask-image: url('./images/radius-l.png');
        left: -12px;
        top: auto;
        transform: none;
      }
    }

    .scroll-btn {
      line-height: 20px;
      display: block;
      box-sizing: border-box;
      width: 20px;
      height: 20px;
      text-align: center;
      cursor: pointer;
      border-radius: 5px;
      z-index: 1;
      background: var(--g-theme-header-action-bg);
      color: var(--g-theme-header-action-color-text);
      .layout-arrow-left2,
      .layout-arrow-right2 {
        font-size: 20px;
      }
      &:hover {
        background: var(--g-theme-header-action-bg-hover);
        color: var(--g-theme-header-action-color-text-hover);
      }
    }
    .scroll-container {
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      width: 100%;
      height: 28px;
      margin: 0;
      margin-left: 8px;
      /* 默认：没有任何遮罩 */
      mask-image: none;

      /* 有左箭头时：左侧 16px 渐隐 */
      &.show-left-mask {
        mask-image: linear-gradient(to right, transparent 0px, black 16px, black 100%);
      }

      /* 有右箭头时：右侧 16px 渐隐 */
      &.show-right-mask {
        mask-image: linear-gradient(to right, black 0%, black calc(100% - 16px), transparent 100%);
      }

      /* 左右都有时：两侧同时渐隐 */
      &.show-left-mask.show-right-mask {
        mask-image: linear-gradient(to right, transparent 0px, black 16px, black calc(100% - 16px), transparent 100%);
      }

      .scroll-wrapper {
        position: absolute;
        display: flex;
        height: 100%;
      }

      .tag {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        font-size: 13px;
        color: var(--g-theme-navbar-color-text);
        padding-left: 12px;
        padding-right: 10px;
        line-height: 28px;
        cursor: pointer;
        .el-icon-close {
          height: 16px;
          line-height: 16px;
          width: 16px;
          text-align: center;
          cursor: pointer;
          color: var(--g-theme-navbar-icon-color);
          z-index: 1;
          &:hover {
            background-color: var(--g-theme-navbar-icon-bg);
            border-radius: 50%;
          }
        }
        &::before {
          content: '';
          width: 1px;
          height: 12px;
          background-color: var(--g-theme-divider);
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          &:first-child {
            display: none;
          }
        }
        &:not(.is-active):first-child {
          &::before {
            display: none;
          }
        }
        &:not(.is-active):hover {
          &::before {
            display: inline-block!important;
            width: calc(100% - 12px);
            height: calc(100% - 6px);
            border-radius: 6px;
            background-color: var(--g-theme-navbar-bg-hover) !important;
            left: 6px;
            top: 13px;
          }
          // color: var(--g-theme-color);
          // background-color: var(--g-theme-navbar-bg-hover) !important;
          // border-radius: 8px 8px 0px 0px;
          // .system-icon {
          //   color: var(--g-theme-color);
          // }
          // .nav-lock-icon {
          //   color: var(--g-theme-color);
          // }
          // .el-icon-close {
          //   color: var(--g-theme-color);
          // }
          // 鼠标悬停时，下一个标签(不是选中状态)的分隔线也隐藏
          & + &:not(.is-active)::before {
            display: none;
          }
        }
        // &:not(.is-active):first-child {
        //   &::before {
        //     display: none;
        //   }
        // }
        div {
          padding-right: 16px;
          position: relative;
          .system-icon {
            color: var(--g-theme-navbar-color-text);
            font-size: 14px;
            margin-right: 4px;
            width: 14px;
            height: 14px;
            display: inline-block;
          }
          .nav-lock-icon {
            width: 8px;
            position: absolute;
            top: 0px;
            right: 5px;
            font-size: 8px;
            font-weight: normal;
            color: var(--g-theme-navbar-color-text);
          }
        }
        // 鼠标悬停时，当前标签(不是选中状态)的分隔线隐藏,并加上圆角
        // &:not(.is-active):hover::before {
        //   @include rounded-corner('before')
        // }
        // &:not(.is-active):hover::after {
        //   @include rounded-corner('after')
        // }
        // 鼠标悬停时，下一个标签(不是选中状态)的分隔线也隐藏
        // &:not(.is-active):hover + .tag:not(.is-active)::before {
        //   display: none;
        // }
      }
      .is-active {
        background-color: var(--g-theme-navbar-bg-active);
        border-radius: 8px 8px 0px 0px;
        position: relative;
        color: var(--g-theme-color);
        filter: url(#hc_extension_highcontrast);
        div {
          .system-icon {
            color: var(--g-theme-color);
          }
          .nav-lock-icon {
            color: var(--g-theme-color);
          }
        }
        .el-icon-close {
          color: var(--g-theme-color);
        }
        &::after {
          @include rounded-corner('after')
        }
        &::before {
          @include rounded-corner('before')
        }
      }
      .is-active span {
        color: var(--g-color-primary);
        font-weight: bold;
      }
      .is-active + .tag {
        &::before {
          display: none;
        }
      }
    }

    .contextmenu {
      position: absolute;
      top: -10px;
      margin: 0;
      z-index: 100;
      padding: 8px;
      color: #453C5A;
      font-size: 14px;
      font-weight: 400;
      background: #fff;
      list-style-type: none;
      border-radius: 12px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
      li {
        margin: 0;
        padding: 8px 10px;
        margin-bottom: 4px;
        line-height: 20px;
        cursor: pointer;
        &:hover {
          background: rgba(247, 247, 255, 1);
          border-radius: 10px;
        }
        &:active {
          color: var(--g-color-primary);
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/layout/navbar.vue